var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-popup',{attrs:{"fullscreen":_vm.fullscreen,"title":_vm.title,"active":_vm.activeValue,"button-close-hidden":_vm.hiddenBoolean},on:{"update:active":function($event){_vm.activeValue=$event}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }